export const name = 'domSelectors' as const

// Re-export from thunderbolt-symbols to avoid circular dependencies
export { DomSelectorsSymbol } from '@wix/thunderbolt-symbols'
